export enum EDeviceEventCode {
  NOT_CHANGED = 0, // 변화 없음
  SYS_STARTED = 1, // Firmware 시작
  SYS_ERROR_EXT_BOARD_CONNECTION = 11, // 확장 보드 연결 에러
  SYS_SUCCEED_EXT_BOARD_RECONNECTION = 12, // 확장 보드 재 연결 성공
  SYS_CASE_OPENED = 20, // 케이스 열림
  SYS_CASE_CLOSE = 21, // 케이스 닫힘
  SYS_DETECTED_FIRE_SIGNAL_FROM_SENSOR = 22, // 화재 수신기로부터 화재 발생 신호 수신
  SYS_RELEASED_FIRE_SIGNAL_FROM_SENSOR = 23, // 화재 수신기로부터 화재 해제 신호 수신
  SYS_DETECTED_FIRE_SIGNAL_FROM_SERVER = 24, // Server로부터 화재 발생 신호 수신
  SYS_RELEASED_FIRE_SIGNAL_FROM_SERVER = 25, // Server로부터 화재 해제 신호 수신
  SYS_DETECTED_BLACKOUT = 26, // 정전 감지
  SYS_RELEASED_FROM_BLACKOUT = 27, // 정전 복구
  // System Event : DB 동기화
  /// <summary>
  /// ACU설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_ACU_CONF = 50,
  /// <summary>
  /// 이벤트 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_EVENT_SAVE_BUZZ = 51,
  /// <summary>
  /// 휴일 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_HOLIDAY_INFO = 52,
  /// <summary>
  /// 출입 스케줄 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_TIME_ACCESS = 53,
  /// <summary>
  /// 동작 스케줄 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_TIME_SCHEDULE = 54,
  /// <summary>
  /// Wiegand 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_WIEGAND_CONFIG = 55,
  /// <summary>
  /// Wiegand 동작 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_WIEGAND_OPERATION = 56,
  /// <summary>
  /// Wiegand 해석방법 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_WIEGAND_RULE = 57,
  /// <summary>
  /// 확장보드 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_EXTENSTION_INFO = 58,
  /// <summary>
  /// 감지 장치 설정 동기화 완료
  /// </summary>
  SYS_SYNC_SUCCEED_UPDATE_INTRUSION_CONFIG_OPERATION = 59,
  /// <summary>
  /// ACU 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_ACU_CONF = 70,
  /// <summary>
  /// 이벤트 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_EVENT_SAVE_BUZZ = 71,
  /// <summary>
  /// 휴일 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_HOLIDAY_INFO = 72,
  /// <summary>
  /// 출입 스케줄 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_TIME_ACCESS = 73,
  /// <summary>
  /// 동작 스케줄 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_TIME_SCHEDULE = 74,
  /// <summary>
  /// Wiegand 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_WIEGAND_CONFIG = 75,
  /// <summary>
  /// Wiegand 동작 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_WIEGAND_OPERATION = 76,
  /// <summary>
  /// Wiegand 해석 방법 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_WIEGAND_RULE = 77,
  /// <summary>
  /// 확장 보드 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_EXTENSTION_INFO = 78,
  /// <summary>
  /// 감지 장치 설정 동기화 실패
  /// </summary>
  SYS_SYNC_FAILED_UPDATE_INTRUSION_CONFIG_OPERATION = 79,

  // 릴레이
  /// <summary>
  /// 릴레이 ON (ACU)
  /// </summary>
  RELAY_ON_BY_ACU = 80,
  /// <summary>
  /// 릴레이 OFF (ACU)
  /// </summary>
  RELAY_OFF_BY_ACU = 81,

  /// <summary>
  /// 릴레이 ON (관리자)
  /// </summary>
  RELAY_ON_BY_ADMIN = 85,
  /// <summary>
  /// 릴레이 OFF (관리자)
  /// </summary>
  RELAY_OFF_BY_ADMIN = 86,

  /// <summary>
  /// 렐레이 스케줄 시작
  /// </summary>
  RELAY_SCHED_BEGUN = 90,
  /// <summary>
  /// 릴레이 스케줄 종료
  /// </summary>
  RELAY_SCHED_END = 91,
  /// <summary>
  /// 릴레이 스케줄 일시정지
  /// </summary>
  RELAY_SCHED_SUSPENDED = 92,
  /// <summary>
  /// 릴레이 스케줄 재개
  /// </summary>
  RELAY_SCHED_RESUME = 93,

  // 출입문 센서
  /// <summary>
  /// 출입문 센서 단선
  /// </summary>
  DOOR_SENSOR_LINE_CUT = 100, // 출입문 센서 단선
  /// <summary>
  /// 출입문 센서 단선 해제
  /// </summary>
  DOOR_SENSOR_LINE_OK = 101, // 출입문 센서 단선 해제
  /// <summary>
  /// 출입문 열림
  /// </summary>
  DOOR_SENSOR_OPENED = 102, // 출입문 열림
  /// <summary>
  /// 출입문 계속 열림
  /// </summary>
  DOOR_SENSOR_KEPT_OPEN = 103, // 출입문 계속 열림
  /// <summary>
  /// 출입문 닫힘
  /// </summary>
  DOOR_SENSOR_CLOSED = 104, // 출입문 닫힘
  /// <summary>
  /// 출입문 강제 열림
  /// </summary>
  DOOR_SENSOR_FORCE_OPEN = 105, // 출입문 강제 열림
  /// <summary>
  /// 강제로 열림 출입문 계속 열림
  /// </summary>
  DOOR_SENSOR_KEPT_FORCE_OPEN = 106, // 강제로 열림 출입문 계속 열림
  /// <summary>
  /// 테일게이트 발생
  /// </summary>
  DOOR_SENSOR_DETECTED_TAIL_GATING = 109, // 테일 게이팅 발생

  // 출구 버튼
  /// <summary>
  /// 출구 버튼 단선
  /// </summary>
  DOOR_BUTTON_LINE_CUT = 110, // 출구 버튼 단선
  /// <summary>
  /// 출구 버튼 단선 해제
  /// </summary>
  DOOR_BUTTON_LINE_OK = 111, // 출구 버튼 단선 해제
  /// <summary>
  /// 폐쇄 또는 개방된 출입문 버튼 누름
  /// </summary>
  DOOR_BUTTON_PRESSED_ON_LOCKED_OR_OPENED = 112, // 폐쇄 또는 개방된 출입문 버튼 누름
  /// <summary>
  /// 출구 버튼 이용한 출입문 개방
  /// </summary>
  DOOR_BUTTON_PRESSED = 113, // 출구 버튼 이용한 출입문 개방
  /// <summary>
  /// 출구 버튼 계속 눌림
  /// </summary>
  DOOR_BUTTON_KEPT_PRESS = 114, // 출구 버튼 계속 눌림

  // 리더 감시
  /// <summary>
  /// 리더 Tamper switch 단선
  /// </summary>
  READER_TAMPER_LINE_CUT = 120, // 리더 Tamper switch 단선
  /// <summary>
  /// 리더 Tamper switch 단선 해제
  /// </summary>
  READER_TAMPER_LINE_OK = 121, // 리더 Tamper switch 단선 해제
  /// <summary>
  /// 리더 Tamper switch 감지됨
  /// </summary>
  READER_TAMPER_DETECTED = 122, // 리더 Tamper switch 감지됨
  /// <summary>
  /// 리더 Tamper switch 계속 감지됨
  /// </summary>
  READER_TAMPER_KEPT_DETECT = 123, // 리더 Tamper switch 계속 감지됨
  /// <summary>
  /// 리더 Tamper switch 복귀
  /// </summary>
  READER_TAMPER_RELEASED = 124, // 리더 Tamper switch 복귀

  // 관리자 제어
  /// <summary>
  /// 관리자 제어 : 출입문 상태 초기화
  /// </summary>
  CTRL_ADMIN_INITIALIZED_STATUS = 130, // 관리자 제어 : 출입문 상태 초기화
  /// <summary>
  /// 관리자 제어 : 출입문 개방
  /// </summary>
  CTRL_ADMIN_OPENED = 131, // 관리자 제어 : 출입문 개방
  /// <summary>
  /// 관리자 제어 : 출입문 개방 종료
  /// </summary>
  CTRL_ADMIN_CLOSED = 132, // 관리자 제어 : 출입문 개방 종료
  /// <summary>
  /// 관리자 제어 : 출입문 폐쇄
  /// </summary>
  CTRL_ADMIN_LOCKED = 133, // 관리자 제어 : 출입문 폐쇄
  /// <summary>
  /// 관리자 제어 : 출입문 폐쇄 종료
  /// </summary>
  CTRL_ADMIN_RELEASED_FROM_LOCK = 134, // 관리자 제어 : 출입문 폐쇄 종료
  /// <summary>
  /// 관리자 제어 : 출입문 1회 개방
  /// </summary>
  CTRL_ADMIN_OPENED_ONCE = 135, // 관리자 제어 : 출입문 1회 개방
  /// <summary>
  /// 관리자 제어 : 출입문 화재 개방 종료
  /// </summary>
  CTRL_ADMIN_RELEASED_FROM_OPEN_BY_FIRE = 136, // 관리자 제어 : 출입문 화재 개방 종료
  /// <summary>
  /// 관리자 제어 : 출입문 화재 폐쇄 종료
  /// </summary>
  CTRL_ADMIN_RELEASED_FROM_LOCK_BY_FIRE = 137, // 관리자 제어 : 출입문 화재 폐쇄 종료
  /// <summary>
  /// 관리자 제어 : 출입문 개방 일시 정지(스케줄)
  /// </summary>
  CTRL_ADMIN_SUSPENDED_SCHED_FROM_OPENED_SCHED = 138, // 관리자 제어 : 출입문 개방 일시 정지(스케줄)
  /// <summary>
  /// 관리자 제어 : 출입문 폐쇄 일시 정지(스케줄)
  /// </summary>
  CTRL_ADMIN_SUSPENDED_SCHED_FROM_LOCKED_SCHED = 139, // 관리자 제어 : 출입문 폐쇄 일시 정지(스케줄)
  /// <summary>
  /// 관리자 제어 : 스케줄 일시 정지 해제
  /// </summary>
  CTRL_ADMIN_RESUMED_SCHED = 140, // 관리자 제어 : 스케줄 일시 정지 해제

  // 스케줄 제어
  /// <summary>
  /// 스케줄 제어 : 출입문 개방
  /// </summary>
  CTRL_SCHED_OPENED = 150, // 스케줄 제어 : 출입문 개방
  /// <summary>
  /// 스케줄 제어 : 출입문 개방 종료
  /// </summary>
  CTRL_SCHED_RELEASED_FROM_OPEN = 151, // 스케줄 제어 : 출입문 개방 종료
  /// <summary>
  /// 스케줄 제어 : 출입문 폐쇄
  /// </summary>
  CTRL_SCHED_LOCKED = 152, // 스케줄 제어 : 출입문 폐쇄
  /// <summary>
  /// 스케줄 제어 : 출입문 폐쇄 종료
  /// </summary>
  CTRL_SCHED_RELEASED_FROM_LOCK = 153, // 스케줄 제어 : 출입문 폐쇄 종료
  /// <summary>
  /// 스케줄 제어 : PIN 입력 시작
  /// </summary>
  CTRL_SCHED_STARTED_PIN_INPUT = 154, // 스케줄 제어 : PIN 입력 시작
  /// <summary>
  /// 스케줄 제어 : PIN 입력 종료
  /// </summary>
  CTRL_SCHED_STOPED_PIN_INPUT = 155, // 스케줄 제어 : PIN 입력 종료
  /// <summary>
  /// 스케줄 제어 : APB 스케줄 적용
  /// </summary>
  CTRL_SCHED_APPLIED_APB = 156, // 스케줄 제어 : APB 스케줄 적용

  // 기타
  /// <summary>
  /// 시스템 제어 : 출입문 개방(화재)
  /// </summary>
  ETC_OPENED_BY_FIRE = 160, // 시스템 제어 : 출입문 개방(화재)
  /// <summary>
  /// 시스템 제어 : 출입문 폐쇄(화재)
  /// </summary>
  ETC_LOCKED_BY_FIRE = 161, // 시스템 제어 : 출입문 폐쇄(화재)
  /// <summary>
  /// 시스템 제어 : 출입문 상태 초기화(화재)
  /// </summary>
  ETC_RELEASED_FROM_FIRE = 162, // 시스템 제어 : 출입문 상태 초기화(화재)

  // 센서
  /// <summary>
  /// 센서 감지
  /// </summary>
  SENSOR_DETECTED = 180, // 센서 감지
  /// <summary>
  /// 센서 계속 감지
  /// </summary>
  SENSOR_KEPT_DETECTED = 181, // 센서 계속 감지
  /// <summary>
  /// 센서 감지 해제 (By Signal)
  /// </summary>
  SENSOR_RETURNED_TO_NORMAL_FROM_DETECTION_BY_SIGNAL = 182, // 센서 감지 해제 (By Signal)
  /// <summary>
  /// 센서 단선
  /// </summary>
  SENSOR_LINE_BREAK = 183, // 센서 단선
  /// <summary>
  /// 센서 단선 해제
  /// </summary>
  SENSOR_RETURNED_TO_NORMAL_FROM_LINE_BREAK = 184, // 센서 단선 해제
  /// <summary>
  /// 센서 감지 (관리자 Relay Off 필요)
  /// </summary>
  SENSOR_DETECTED_NEED_ADMIN_RELAY_OFF = 185, // 센서 감지 (관리자 Relay Off 필요)
  /// <summary>
  /// 센서 감지 (관리자 Relay On/Off 필요)
  /// </summary>
  SENSOR_DETECTED_NEED_ADMIN_RELAY_ON_OFF = 186, // 센서 감지 (관리자 Relay Off 필요)
  /// <summary>
  /// 센서 감지 안됨 (초기상태)
  /// </summary>
  SENSOR_NOT_DETECTED = 189, // 센서 감지 안됨 (초기상태)

  /// <summary>
  /// 센서 활성화 스케줄 시작
  /// </summary>
  SENSOR_ACTIVATION_SCHEDULE_BEGUN = 190, // 센서 활성화 스케줄 시작
  /// <summary>
  /// 센서 활성화 스케줄 종료
  /// </summary>
  SENSOR_ACTIVATION_SCHEDULE_END = 191, // 센서 활성화 스케줄 종료

  /// <summary>
  /// 센서와 연결된 릴레이 동작
  /// </summary>
  SENSOR_LINKED_RELAY_WORKED = 195, // 센서와 연결된 릴레이 동작
  /// <summary>
  /// 센서 활성화
  /// </summary>
  SENSOR_ACTIVATED = 196, // 센서 활성화
  /// <summary>
  /// 센서 비 활성화
  /// </summary>
  SENSOR_DEACTIVATED = 197, // 센서 비 활성화
  /// <summary>
  /// 센서 제어 해제
  /// </summary>
  //SENSOR_RETURNED_TO_NORAML = 198,                          // 센서 제어 해제  (삭제됨 : 160928)
  /// <summary>
  /// 센서 감지 해제 (By Admin)
  /// </summary>
  SENSOR_RETURNED_TO_NORMAL_FROM_DETECTION_BY_ADMIN = 199, // 센서 감지 해제 (By Admin)

  // 사용자 인증
  /// <summary>
  /// 인증 성공 : 정상 출입 (입구)
  /// </summary>
  AUTH_OK_ENT = 200, // 인증 성공 : 정상 출입 (입구)
  /// <summary>
  /// 인증 성공 : 정상 출입 (출구)
  /// </summary>
  AUTH_OK_EXIT = 201, // 인증 성공 : 정상 출입 (출구)
  /// <summary>
  /// 인증 성공 : 관리자 출입 (입구)
  /// </summary>
  AUTH_OK_ADMIN_ENT = 202, // 인증 성공 : 관리자 출입 (입구)
  /// <summary>
  /// 인증 성공 : 관리자 출입 (출구)
  /// </summary>
  AUTH_OK_ADMIN_EXIT = 203, // 인증 성공 : 관리자 출입 (출구)
  /// <summary>
  /// 인증 성공 : 이중 인증
  /// </summary>
  AUTH_OK_DOUBLE_AUTH = 204, // 인증 성공 : 이중 인증
  /// <summary>
  /// 인증 성공 : 카드를 통한 출입문 개방
  /// </summary>
  AUTH_OK_USER_DOOR_OPEN = 205, // 인증 성공 : 카드를 통한 출입문 개방
  /// <summary>
  /// 인증 성공 : 카드를 통한 출입문 해제
  /// </summary>
  AUTH_OK_USER_DOOR_CLOSE = 206, // 인증 성공 : 카드를 통한 출입문 해제
  /// <summary>
  /// 인증 성공 : 테스트 인증
  /// </summary>
  AUTH_OK_TEST_AUTH = 207, // 인증 성공 : 테스트 인증

  /// <summary>
  /// 인증 실패 : 미 등록 ID
  /// </summary>
  AUTH_ERR_UNREGISTERED_MEDIA = 210, // 인증 실패 : 미 등록 ID
  /// <summary>
  /// 인증 실패 : 유효성 에러
  /// </summary>
  AUTH_ERR_INVALID_MEDIA = 211, // 인증 실패 : 유효성 에러
  /// <summary>
  /// 인증 실패 : 분실 사용자
  /// </summary>
  AUTH_ERR_LOSTED_MEDIA = 212, // 인증 실패 : 분실 사용자
  /// <summary>
  /// 인증 실패 : 정지 사용자
  /// </summary>
  AUTH_ERR_STOPPED_MEDIA = 213, // 인증 실패 : 정지 사용자
  /// <summary>
  /// 인증 실패 : 유효 기간 초과 사용자
  /// </summary>
  AUTH_ERR_OUT_OF_PERIOD = 214, // 인증 실패 : 유효 기간 초과 사용자
  /// <summary>
  /// 인증 실패 : 출입 제한 지역
  /// </summary>
  AUTH_ERR_RESTRICT_AREA = 215, // 인증 실패 : 출입 제한 지역
  /// <summary>
  /// 인증 실패 : 출입 제한 시간
  /// </summary>
  AUTH_ERR_RESTRICT_TIME = 216, // 인증 실패 : 출입 제한 시간
  /// <summary>
  /// 인증 실패 : 중복 출입 (입구)
  /// </summary>
  AUTH_ERR_ANTIPASS_DUPLICATED_IN = 217, // 인증 실패 : 중복 출입 (입구)
  /// <summary>
  /// 인증 실패 : 중복 출입 (출구)
  /// </summary>
  AUTH_ERR_ANTIPASS_DUPLICATED_OUT = 218, // 인증 실패 : 중복 출입 (출구)
  /// <summary>
  /// 인증 실패 : 출입문 유효기간 초과
  /// </summary>
  AUTH_ERR_OUT_OF_PERIOD_ON_DOOR = 219, // 인증 실패 : 출입문 유효기간 초과
  /// <summary>
  /// 인증 실패 : PIN 입력 오류
  /// </summary>
  AUTH_ERR_PIN = 220, // 인증 실패 : PIN 입력 오류
  /// <summary>
  /// 인증 실패 : 정의되지 않은 출입 시간
  /// </summary>
  AUTH_ERR_UNDEFINED_ACCESS_TIME = 221, // 인증 실패 : 정의되지 않은 출입 시간
  /// <summary>
  /// 인증 실패 : 이중 인증
  /// </summary>
  AUTH_ERR_DOUBLE_AUTHENTICATION = 222, // 인증 실패 : 이중 인증
  /// <summary>
  /// 인증 실패 : 안면 인증
  /// </summary>
  AUTH_ERR_FACE_AUTHENTICATION = 223, // 인증 실패 : 안면 인증
  /// <summary>
  /// 인증 제한 : 인증 제한 시간(반복 출입)
  /// </summary>
  AUTH_ERR_ANTIPASS_TIME = 230, // 인증 제한 : 인증 제한 시간(반복 출입)
  /// <summary>
  /// 인증 제한 : 개방 된 문 인증
  /// </summary>
  AUTH_ERR_AUTH_ON_OPENED_DOOR = 231, // 인증 제한 : 개방 된 문 인증
  /// <summary>
  /// 인증 제한 : 폐쇄 된 문 인증
  /// </summary>
  AUTH_ERR_AUTH_ON_LOCKED_DOOR = 232, // 인증 제한 : 폐쇄 된 문 인증
  /// <summary>
  /// 인증 제한 : 등록 되지 않은 출입문 ID 수신 (관리목적)
  /// </summary>
  AUTH_ERR_PORT_NOT_IN_MANAGEMENT = 233, // 인증 제한 : 등록 되지 않은 출입문 ID 수신 (관리목적)
  /// <summary>
  /// 인증 제한 : 설정되지 않은 ID 형식 수신(Wiegand bit 에러)
  /// </summary>
  AUTH_ERR_INVALID_ID_FORMAT = 234 // 인증 제한 : 설정되지 않은 ID 형식 수신(Wiegand bit 에러)
}
